import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing a table report view for hash data.
 */
export default class tableReportHashView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            view: 'datatable', // Define the view as a datatable
            id: 'datatable', // Set the ID for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
            columns: [
                // Define columns for the datatable
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: _('Descargar'), // Tooltip for download icon
                    template: function (obj) {
                        // Template for the download icon
                        return "<span class='webix_icon wxi-close download'></span>";
                    },
                },
                { id: 'Id', header: _('ID'), width: 100, sort: 'int' }, // Column for ID
                {
                    id: 'FileName',
                    header: _('Nombre Archivo'), // Column for file name
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'Platform',
                    header: _('Plataforma'), // Column for platform
                    editor: 'combo', // Combo editor for this column
                    options: [{ id: '0', value: _('Backend') }], // Options for the combo
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'OriginalHash',
                    header: _('Hash Original'), // Column for original hash
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'DetectedHash',
                    header: _('Hash Detectado'), // Column for detected hash
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'ModificationDate',
                    header: _('Fecha modificación'), // Column for modification date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Format for the date
                },
                {
                    id: 'LastDetectionDate',
                    header: _('Fecha ultima detección'), // Column for last detection date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Format for the date
                },
            ],
            onClick: {
                // Event handler for click events
                download: function (euv, id) {
                    // Download action
                    var item = this.getItem(id); // Get the clicked item
                    window.open(item.PdfUrl); // Open the PDF URL
                },
            },
            ready: function () {
                // Event handler for when the datatable is ready
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show overlay message
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // No data message
                            '</div>',
                    );
                }
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/ReportHash/GetReportHash', // API URL for data
            data: [
                // Initial data for the datatable
                {
                    Id: '01',
                    // Filename generation
                    filename:
                        'Virtualsoft - ' +
                        new Date()
                            .toLocaleString('en-GB', { hour12: true }) // Current date and time
                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1') // Date format adjustment
                            .replace(/[\/:]/g, '_') // Replace slashes and colons
                            .toUpperCase() +
                        ' - ' +
                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) + // Conditional message for no data
                        'Primer',
                    OriginalHash: 'OriginalHash', // Placeholder for original hash
                    DetectedHash: 'DetectedHash', // Placeholder for detected hash
                    ModificationDate: '2019-07-29', // Sample modification date
                    LastDetectionDate: '2019-07-29', // Sample last detection date
                    PdfUrl: 'https://docs.webix.com/samples/60_pro/10_viewers/files/WebixDocs.pdf', // Sample PDF URL
                },
            ],
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // Store the data URL
        var filter = ''; // Initialize filter string
        const cur_user = this.getParam('user', true); // Get current user parameter

        this.on(this.app, 'reportHash:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'CreatedLocalDate') {
                        // Handle created local date
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            // Handle modified local date
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to query
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format dateFrom for query
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format dateTo for query
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                // Load sorted data
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir,
            );
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item clicks
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                // Load data based on selected player
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
    }
}

// FILE DOCUMENTED
